import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbSlider } from '../../types/pbBlocks';
import { parseStyleString, getAdvanced } from '../utils';

export type SliderType = ContentTypeObject & PbSlider;

/**
 * Aggregates the configuration of a slider element.
 * @param node
 */
export function sliderConfigAggregator(node: CustomHtmlElement): SliderType {
    const autoplaySpeed = parseInt(node.attributes['data-autoplay-speed']);
    const style = parseStyleString(node.attributes.style);
    const showDesktop = parseInt(node.attributes['data-show-desktop']);
    const showTablet = parseInt(node.attributes['data-show-tablet']);
    const showMobile = parseInt(node.attributes['data-show-mobile']);

    return {
        ...(!isNaN(autoplaySpeed) && { autoplaySpeed }),
        ...getAdvanced(node, style),
        autoplay: node.attributes['data-autoplay'] === 'true',
        fade: node.attributes['data-fade'] === 'true',
        infinite: node.attributes['data-infinite-loop'] === 'true',
        minHeight: style?.minHeight,
        showArrows: node.attributes['data-show-arrows'] === 'true',
        showDesktop: showDesktop || 1,
        showDots: node.attributes['data-show-dots'] === 'true',
        showMobile: showMobile || 1,
        showTablet: showTablet || 1,
        uniqueID: node.attributes['data-pb-style'],
    };
}
